module.exports = __webpack_public_path__ + "static/illustration-c2c37a8d974cdab55db9b21be19f8d34.svg";